import React, { useState, useEffect, useCallback } from "react";
import Header from '../components/Header'
import Footer from '../components/Footer'
import MobileNav from '../components/MobileNav'
import Breadcrumb from '../components/Breadcrumb'
import { Link } from 'react-router-dom';
import axios from 'axios';
import Preloader from '../components/Preloader'
import usePageSEO from '../hooks/usePageSEO'
import ServiceSection from "../components/ServiceSection";

const Services = () => {
  const [loading, setLoading] = useState(true)
  const [seoData, setSeoData] = useState([]);

  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  
    const fetchPagedata = async () => {
      try {
        const [seoRes] = await Promise.all([
          axios.get(apiBaseUrl + "seo?page=service"),
        ]);
        setSeoData(seoRes.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchPagedata();
      setLoading(false);
    }, 1000); // 1 seconds
    return () => clearTimeout(timer);
  }, [fetchPagedata]);


  usePageSEO({
    title: `${seoData?.meta_title}`,
    description: `${seoData?.meta_description}`
  })    
  return (
    <>
    <div className="page-wrapper">
      <Header />
      <Breadcrumb />
      { loading && ( <Preloader /> )}
      <ServiceSection />
      <Footer />
    </div>

    <MobileNav />
    </>
  )
}

export default Services